module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/wine@3x_28a381.jpg";